import redirectToUrl from '@/application/training/goTrainingUrl/RedirectToUrl';

export default class RedirectToTrainingUrl implements redirectToUrl {
  async redirect(url: string, token: string): Promise<void> {
    window.open(`${url}/loginSSOJWT?jwt=${token}`, '_blank');
  }
}
